import "../../../field.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.VisitStep ??= {};

AppointmentBooking.Wizard.Views.VisitStep.SlotField = class SlotField extends AppointmentBooking.Wizard.Views.Field {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
  }

  initialize() {
    super.initialize(...arguments);

    return this.listenTo(this.model, "change:appointment_slot", this.render);
  }
};
AppointmentBooking.Wizard.Views.VisitStep.SlotField.prototype.template = "step/visit/fields/slot";
AppointmentBooking.Wizard.Views.VisitStep.SlotField.prototype.className =
  "appointment-booking-wizard-visit-step-slot-field";
